import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { callApi, getInlineLoader, setCookie } from "../Helpers";
import {
	STR_CHANGE_PHONE_NUMBER,
	STR_CLIENTS,
	STR_CONSULTATION_FEE_PAYMENTS,
	STR_CONTACT_US,
	STR_INTEGRATE_NEW_ACCOUNT,
	STR_LEADS,
	STR_LOGOUT,
	STR_MY_COACH,
	STR_MY_STUDENTS,
	STR_NO_RECORD,
	STR_PAYMENT_SETTINGS,
	STR_PERSONAL_SETTINGS,
	STR_SEND_MESSAGE,
	STR_SEND_MESSAGE_TO_CLIENTS,
	STR_SEND_MESSAGE_TO_LEADS,
	STR_SET_CURRENCY,
	STR_SUBSCRIPTION_FEE_PAYMENTS,
	STR_UPDATE_PERSONAL_INFO,
	STR_UPDATE_USERNAME,
	STR_USER_REPORT,
	STR_WHATSAPP_SETUP
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear, BsSendCheck } from 'react-icons/bs';
import { MdAnalytics, MdContactPage, MdInfoOutline, MdLogout, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup, MdOutlineSupport, MdPerson, MdSupportAgent, MdTranslate, MdWhatsapp } from 'react-icons/md';
import { CgProfile } from "react-icons/cg";
import { GrCurrency } from "react-icons/gr";
import { GiTeacher } from "react-icons/gi";
import { BiSolidDashboard } from "react-icons/bi";
import OneContact from '../ones/OneContact';

export default function View({ businessUid }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [businessData, setBusinessData] = useState(null);
	const [businessCustomers, setBusinessCustomers] = useState(null);
	const [leads, setLeads] = useState(null);
	const [clients, setClients] = useState(null);
	const [customerLevel, setCustomerLevel] = useState('clients');

	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			getBusinessData(),
			getBusinessCustomers(),
		])
		setReady(true);
	}

	function processCustomers() {
		if(businessCustomers) {
			const _leads = [];
			const _clients = [];

			function getWhatsAppNumber(_customer) {
				const otherChannels = JSON.parse(_customer.otherCommunicationChannels);

				if(otherChannels) {
					for (const channel of otherChannels) {
						if(channel.id === 'whatsapp') {
							return channel.value;
						}
					}
				}

				return "";
			}

			for (const customer of businessCustomers) {
				const contact = {
					id: customer.id,
					name: customer.name,
					phoneNumber: customer.phone,
					whatsAppNumber: getWhatsAppNumber(customer),

				}

				if(customer.customerLevel === 'lead') {
					_leads.push(contact);
				} else if(customer.customerLevel === 'client') {
					_clients.push(contact);
				}

				
			}

			setLeads(_leads);
			setClients(_clients);
		}
	}

	async function getBusinessData() {
		await callApi('get-mauzo-crm-account-data', { businessUid }).then(response => {
			if(response.status === 1) {
				setBusinessData(response.data)
			}
		})
	}

	async function getBusinessCustomers() {
		await callApi('get-mauzo-crm-account-customers', { businessUid }).then(response => {
			if(response.status === 1) {
				setBusinessCustomers(response.data)
			}
		})
	}

	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		processCustomers()
	}, [ businessCustomers ])

	if (ready && businessData && businessCustomers) {
		return (
			<div
				style={{
					width: "100%",
					height: "100%",
					overflow: "scroll",
					paddingTop: "20px",
				}}
				className="mNoScrollBar"
			>
				<div className="container">

					<div className="row">

						

						<div className="col-md-12">
							<div className="card">
								<div className="card-body text-center">
									<h6
										style={{
											fontSize: "24px"
										}}
										className="font-semi-bold"
									>
										{businessData.name}
									</h6>
									<h6
										style={{
											fontSize: "16px"
										}}
										className="text-muted"
									>
										{businessData.uid}
									</h6>

									<hr/>

									<div className="row">
										<div className="col-12">
											<button
												className="btn btn-block btn-dark"
												onClick={() => {
													appContext.navTo({
														item: 'view',
														subItem: 'create-message',
														extraItem: 'mauzocrm',
														moreItem: businessUid,
													})
												}}
											>
												{STR_SEND_MESSAGE[appContext.language]}
											</button>
										</div>

										
									</div>
								</div>
							</div>
						</div>

						<div className="col-md-12">
							<div className="">
								<select
									className="form-control"
									value={customerLevel}
									onChange={(e) => setCustomerLevel(e.target.value)}
								>
									<option value="leads">{STR_LEADS[appContext.language]}</option>
									<option value="clients">{STR_CLIENTS[appContext.language]}</option>
								</select>
							</div>

							<hr/>

							{
								(customerLevel === 'leads') ?
								(leads && leads.length > 0) ?
								leads.map((item, i) => {
									return (
										<OneContact canView={false} key={i} data={item}/>
									)
								})
								:
								<h6
									style={{
										fontSize: "14px"
									}}
								>
									{STR_NO_RECORD[appContext.language]}
								</h6>
								:""
							}

							{
								(customerLevel === 'clients') ?
								(clients && clients.length > 0) ?
								clients.map((item, i) => {
									return (
										<OneContact canView={false} key={i} data={item}/>
									)
								})
								:
								<h6
									style={{
										fontSize: "14px"
									}}
								>
									{STR_NO_RECORD[appContext.language]}
								</h6>
								:""
							}
						</div>

					</div>

				</div>


			</div>
		)
	} else {
		return (
			<div
				className="mSupportLoading"
				style={{
					width: "100%",
					height: "100%",
				}}
			>
				{getInlineLoader()}
			</div>
		);
	}


}